import LogoutIcon from "@mui/icons-material/Logout";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import React, { useContext, useEffect } from "react";

import { UserContext } from "../../../Context/UserContext";
import { Error } from "../../../Utils/Errors";
import { LocalStorageConfigs, clearLocalStorage } from "../../../Utils/LocalStorage";
import { useApi } from "../../../Utils/useApi";

const Logout: React.FC = () => {
  const { ivrState, logOutProtocol, token, setLogOutProtocol } = useContext(UserContext);

  // push deletion of ivr token to GEM if ivr connected but not available
  const { response, error } = useApi({
    method: "delete",
    url: "Legacy/V0/Token",
    config: { headers: { Authorization: `Bearer ${token?.token}` } },
    valid: logOutProtocol === "manual" && ivrState.state !== "Available",
    error: Error.DeleteToken
  });
  useEffect(() => {
    if (!logOutProtocol) return;
    if (logOutProtocol === "error") localStorage.removeItem(LocalStorageConfigs.token.key);
    // if manual logout method, await completion of the delete token request
    if (logOutProtocol === "manual" && ivrState.state !== "Available" && !response && !error) return;
    clearLocalStorage();
    window.location.reload();
  }, [response, error, logOutProtocol, ivrState.state]);

  return logOutProtocol ? (
    <Box px={1.5}>
      <CircularProgress color="secondary" />
    </Box>
  ) : (
    <Tooltip title="Log Out">
      <IconButton size="large" color="inherit" onClick={() => setLogOutProtocol("manual")}>
        <LogoutIcon fontSize="large" />
      </IconButton>
    </Tooltip>
  );
};

export default Logout;
